import { render, staticRenderFns } from "./select-warehouse.vue?vue&type=template&id=654930c1"
import script from "./select-warehouse.vue?vue&type=script&lang=js"
export * from "./select-warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports